import { NgModule, Provider } from '@angular/core';
import dayjs from 'dayjs';

export function dayjsFactory() {
  return dayjs;
}

const DAYJS_PROVIDER: Provider = {
  provide: 'DAYJS',
  useFactory: dayjsFactory,
};

@NgModule({
  providers: [DAYJS_PROVIDER],
})
export class DayJsModule {}